import { Box } from '@bonanza-social/moonlight';
import { memo, useMemo } from 'react';
import ShopBadgeItem from '../ShopBadgeItem/ShopBadgeItem';
import { useTranslation } from '@bonanza-social/i18n';
import { ShopBadgeListProps } from './ShopBadgeList.types';

function ShopBadgeList({ sale }: ShopBadgeListProps) {
  const { availableItems, percentage, label, displayAvailableItems } = sale;

  const [t] = useTranslation('shop');

  const isSaleItemAvailable =
    availableItems === undefined || (availableItems && availableItems > 0);
  const isSaleItemSoldOut =
    availableItems !== undefined && availableItems === 0;

  const showSaleBadge = percentage && isSaleItemAvailable;
  const showHighlightBadge = label && isSaleItemAvailable;
  const showSoldOutBadge = displayAvailableItems && isSaleItemSoldOut;

  const saleBadgeText = useMemo(
    () => (showSaleBadge ? t('saleBadge', { percentage }) : null),
    [t, showSaleBadge, percentage],
  );
  const highlightBadgeText = useMemo(
    () => (showHighlightBadge ? label : null),
    [showHighlightBadge, label],
  );
  const soldOutBadgeText = useMemo(
    () => (showSoldOutBadge ? t('soldOutBadge') : null),
    [t, showSoldOutBadge],
  );

  return (
    <Box position="absolute" zIndex={10} gap="space-200" paddingTop="space-500">
      {saleBadgeText ? (
        <ShopBadgeItem
          text={saleBadgeText}
          variant="gradient"
          gradient="accentBackground"
          textColor="accentSurfacePrimary"
          alignSelf="flex-start"
        />
      ) : null}
      {highlightBadgeText ? (
        <ShopBadgeItem
          text={highlightBadgeText}
          backgroundColor="primaryBackground"
          textGradient="darkSurfaceAccent"
          alignSelf="flex-start"
        />
      ) : null}
      {soldOutBadgeText ? (
        <ShopBadgeItem
          text={soldOutBadgeText}
          backgroundColor="primaryBackground"
          textColor="darkSurfacePrimary"
          alignSelf="flex-start"
        />
      ) : null}
    </Box>
  );
}

export default memo(ShopBadgeList);
